import React, { Component } from "react";
import UpdateExtraCurricularActivity from "./updatedExtraCurricularActivity";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import Button from "@material-ui/core/Button";
import Popup from "../../../../common/popup";
import DateFns from "date-fns";

/**
 * ExtraCurricular Component for displaying the user ExtraCurricular details.
 */
class ExtraCurricular extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addBtn: false,
      updateBtn: false,
      data: [],
      isOpen: false,
      deletePopupId :"",
      updateData: null,
      validid: false,
    };
    this.openAddForm = this.openAddForm.bind(this);
    this.closeAddForm = this.closeAddForm.bind(this);
    this.openUpdateForm = this.openUpdateForm.bind(this);
    this.closeUpdateForm = this.closeUpdateForm.bind(this);
    this.getData = this.getData.bind(this);
    this.deleteAward = this.deleteAward.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    
  }

  // open add form

  openAddForm() {
    this.setState({
      updateBtn: true,
      updateData: null,
    });
  }
  // close add form

  closeAddForm() {
    this.setState({
      addBtn: false,
    });
  }

  // open update form
  openUpdateForm(detail) {
    this.setState({
      updateBtn: true,
      updateData: detail,
    });
  }
  // close update form
  closeUpdateForm() {
    this.setState({
      updateBtn: false,
    });
    this.getData();
  }

  // toogle delete popup
  togglePopup(detail) {
    this.setState({
      isOpen: !this.state.isOpen,
      deletePopupId: detail
    });
  }

  componentDidMount() {
    this.getData();
  }

  //  function for  getting extracurricular data

  getData() {
    axios
      .get(`${API_CANDIDATE}/v1/api/can-extracurricular`, { withCredentials: true })
      .then((res) => {
        console.log(res);

        this.setState({
          data: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // delete function

  deleteAward(obj) {
    console.log("chandra", obj);

    if (this.state.data === undefined) {
      return;
    }
    let body = {
      id: obj,
    };

    console.log(body);

    axios
      .delete(`${API_CANDIDATE}/v1/api/can-extracurricular`, {
        withCredentials: true,
        data: body,
      })
      .then((res) => {
        console.log(res);
        if (res.data.ok) {
          this.getData();
          this.setState({
            isOpen: false,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

 

  render() {
    const { addBtn, updateBtn, data } = this.state;

    return (
      <>
      {/* applied ternary operator */}
        {!addBtn && !updateBtn ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="details-flex-main-div"
            >
              <div style={{ paddingTop: "20px", height: "60px" }}>
                <h5  style={{ fontWeight: 500,fontSize:"1.25rem" }}>
                  {" "}
                  Extracurricular Activities{" "}
                </h5>
              </div>
              <Button
                onClick={this.openAddForm}
                type="submit"
                style={{
                  background: "green",
                  marginTop: "10px",
                  color: "white",
                }}
                className="btn login-button white-text"
              >
                ADD
              </Button>
            </div>

            {this.state.data.map((detail) => (
              <div
                key={detail.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  background: "#FFE8",
                  marginBottom: "30px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    paddingLeft: "2rem",
                    paddingBottom: "15px",
                    width: "100%",
                    marginTop: "20px",
                    borderRadius: "15px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1.5rem",
                    }}
                  >
                    <span style={{fontWeight: "500", fontSize:"0.875rem", flexBasis: "10rem" }}>
                     Activity Type{" "}
                    </span>
                    <span style={{  width: "40px" }}>:</span>
                    <span className="nostyle" style={{  flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem" }}>
                      {detail.extCurActType}
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1.5rem",
                    }}
                  >
                    <span style={{ fontWeight: "500", fontSize:"0.875rem",  flexBasis: "10rem" }}>
                       Activity Name{" "}
                    </span>
                    <span style={{  width: "40px" }}>:</span>
                    <span className="nostyle" style={{flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem" }}>
                      {detail.extCurActName}
                    </span>
                  </div>

                  <div
                    style={{
                    
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1.5rem",
                    }}
                  >
                    <span style={{ fontWeight: "500", fontSize:"0.875rem",  flexBasis: "10rem"}}>
                      Comments
                    </span>
                    <span style={{  width: "40px" }}>:</span>
                    <span className="nostyle" style={{  flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem" }}>
                      {detail.Comments}
                    </span>
                  </div>
                  <div
                    style={{
                   
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1.5rem",
                    }}
                  >
                    <span style={{fontWeight: "500", fontSize:"0.875rem",   flexBasis: "10rem"}}>
                      Start Date
                    </span>
                    <span style={{  width: "40px" }}>:</span>
                    <span className="nostyle" style={{  flex: 8,fontWeight: "400", fontSize:"0.75rem" }}>
                    
                      { detail.fromDate
                            ? DateFns.format(
                              detail.fromDate,
                                "DD-MM-YYYY"
                              )
                            : ""}
                    </span>
                  </div>
                  <div
                    style={{
                    
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1.5rem",
                    }}
                  >
                    <span style={{fontWeight: "500", fontSize:"0.875rem",  flexBasis: "10rem" }}>
                      End Date
                    </span>
                    <span style={{ width: "40px" }}>:</span>
                    <span style={{  flex: 8,fontWeight: "400", fontSize:"0.75rem" }}>
                    
                      { detail.toDate
                            ? DateFns.format(
                              detail.toDate,
                                "DD-MM-YYYY"
                              )
                            : ""}
                    </span>
                  </div>
                </div>

                <div>
                  <i
                    style={{ color: "green", marginRight: "10px" }}
                    className="material-icons pointer edit-btn"
                    onClick={() => this.openUpdateForm(detail)}
                  >
                    edit
                  </i>

                  <i
                    style={{ color: "red" }}
                    // style={{ marginLeft: "1230px", marginBottom: "-500px", color: "red" }}
                    onClick={() => this.togglePopup(detail)}
                    className="material-icons pointer contact-delete-btn"
                  >
                    delete
                  </i>
                </div>

                {this.state.isOpen && (
                  <Popup
                    isOpenModal={this.togglePopup}
                    isOnDelete={this.deleteAward}
                    detail={this.state.deletePopupId}
                  />
                )}
              </div>
            ))}
          </>
        ) : null}
        {updateBtn && (
          <UpdateExtraCurricularActivity
            updateDataProp={this.state.updateData}
            back={this.closeUpdateForm}
            data={data}
          />
        )}
      </>
    );
  }
}

export default ExtraCurricular;
